import type { NavItem, ServiceKey, SiteConfig } from '@/types'

import { getOrigin } from '@/lib/window'
import { MEDIA } from '@/constants/media'

export const siteConfig: SiteConfig = {
    name: "Localboost",
    legalName: "Localboost LLC",
    description: "Modern and effective web design, SEO and SEM and print design. Over 12 years of serving our beloved clients. Let Localboost help your business grow.",
    url: getOrigin(),
    location: "Fort Worth, Texas, USA",
    timeZone: 'America/Chicago',
    ogImage: MEDIA.shopOwner.src
}

export const NAV_ITEMS: Array<NavItem> = [
    { label: "Why us", href: 'why-us', index: '01' },
    { label: "Services", href: 'services', index: '02' },
    { label: "Sample designs", href: 'examples', index: '03' }
]

export const QUOTE_HASH = 'request-quote'

export const HERO = {
    eyebrow: "In the results business",
    sub: "Boost your online presence with expert web design and SEO services. Unleash the power of stunning websites and top search engine rankings.",
    proofs: [
        "Up to 500% increase in traffic",
        "2x–3x higher conversion rate",
        "Professional websites with results"
    ]
}

export const WHY_CHECKS = [
    "Excellent communication & fast turnarounds",
    "Get more qualified visitors to your website",
    "Turn casual visitors into paying clients"
]

export type ServiceContent = {
    key: ServiceKey
    index: string
    title: Array<string>
    label: string
    description: string
    cta: string
    status?: string
}

export const SERVICES: Array<ServiceContent> = [
    {
        key: 'web-design',
        index: '01',
        title: ["Web Design", "with Results"],
        label: "Web design",
        description: "Want a beautiful, professional website that converts casual visitors into paying clients?",
        cta: "Get started"
    },
    {
        key: 'seo',
        index: '02',
        title: ["SEO & Lead", "Generation"],
        label: "SEO & lead generation",
        description: "Pretty websites don't pay off unless they get traffic. We are experts in bringing qualified leads to you.",
        cta: "Ask about availability",
        status: "Currently not taking new SEO clients"
    },
    {
        key: 'print',
        index: '03',
        title: ["Print", "Design"],
        label: "Print design",
        description: "Need to promote your business with a brochure or mailer? Have the next bestseller, but need it formatted? We've got you.",
        cta: "Get it done"
    }
]

export const SERVICE_LABELS: Record<ServiceKey, string> = {
    'web-design': "Web design",
    seo: "SEO & lead generation",
    print: "Print design"
}

export type Stat = {
    value: string
    suffix?: string
    label: string
}

export const STATS: Array<Stat> = [
    { value: '12.5', label: "years in business" },
    { value: '106', label: "happy partners" },
    { value: '213', suffix: '+', label: "completed projects" }
]

export const COPYRIGHT_YEAR = 2026
